export default "__VITE_ASSET__5e62679f__"